import DatePicker from 'components/calendar/date';
import { IFilterConfig, IFilterConfigDate } from 'components/filter/types';
import React from 'react';
import { formatDate, toIsoStringWithTz } from 'utils/date-format';

interface IProps {
  item: IFilterConfig;
  setValue: (arg1: string, arg2: number, arg3: string) => void;
}

const DateExport = ({ item, setValue }: IProps): JSX.Element => {
  const { key, data } = item;
  const { values } = data as IFilterConfigDate;
  const dateFrom =
    values[0] ||
    toIsoStringWithTz(new Date(new Date().setDate(new Date().getDate() - 30)));
  const dateTo =
    values[1] ||
    toIsoStringWithTz(new Date(new Date().setDate(new Date().getDate())));

  return (
    <div className="rdt-in-modal flex items-end gap-4 pb-5 pt-2">
      <div className="flex-1">
        <div className="pb-1 text-sm font-medium text-gray-blue-80">
          Start date
        </div>

        <DatePicker
          className="w-full"
          initialValue={dateFrom ? formatDate(dateFrom, 'MM-dd-yyyy') : ''}
          setDate={(val: string) => setValue(key, 0, val)}
          beforeDate={formatDate(dateTo, 'dd MMM yyyy')}
          format="MM-DD-YYYY"
        />
      </div>

      <div className="flex-1">
        <div className="pb-1 text-sm font-medium text-gray-blue-80">
          End date
        </div>

        <DatePicker
          className="w-full"
          initialValue={dateTo ? formatDate(dateTo, 'MM-dd-yyyy') : ''}
          setDate={(val: string) => setValue(key, 1, val)}
          afterDate={formatDate(dateFrom || '', 'dd MMM yyyy')}
          isEndDate
          format="MM-DD-YYYY"
        />
      </div>
    </div>
  );
};

export default DateExport;
